module.exports = __webpack_public_path__ + "img/letter_head_ani.29e8580e.png";